import { Props } from 'props';
import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import { URL_API } from '../../config';

type ContextProps = {
  urlLogo: string;
  urlBanner: string;
  urlTerm: string;
  setUrlTerm: Dispatch<SetStateAction<string>>;
  setUrlLogo: Dispatch<SetStateAction<string>>;
  setUrlBanner: Dispatch<SetStateAction<string>>;
};
const ImageContext = createContext({} as ContextProps);

export const ImageProvider: React.FC<Props> = ({ children }) => {
  const [urlLogo, setUrlLogo] = useState(
    `${URL_API}/download/by-file-name?FileName=logo&Extension=jpg`
  );
  const [urlBanner, setUrlBanner] = useState(
    `${URL_API}/download/by-file-name?FileName=banner&Extension=jpg`
  );
  const [urlTerm, setUrlTerm] = useState(
    `${URL_API}/download/by-file-name?FileName=termos&Extension=pdf`
  );

  return (
    <ImageContext.Provider
      value={{
        urlLogo,
        setUrlLogo,
        urlBanner,
        setUrlBanner,
        urlTerm,
        setUrlTerm,
      }}
    >
      {children}
    </ImageContext.Provider>
  );
};

export const useImages = () => useContext(ImageContext);
